import dataManagementLight from "../../../../contents/images/features/data-management/data-management-light-mode.png";
import dataManagementDark from "../../../../contents/images/features/data-management/data-management-dark-mode.png";
import definitionCardLight from "../../../../contents/images/features/data-management/definition-card-edit-light-mode.png";
import definitionCardDark from "../../../../contents/images/features/data-management/definition-card-edit-dark-mode.png";
import warningsLight from "../../../../contents/images/features/data-management/warnings-light-mode.png";
import warningsDark from "../../../../contents/images/features/data-management/warnings-dark-mode.png";
import * as React from 'react';
export default {
  dataManagementLight,
  dataManagementDark,
  definitionCardLight,
  definitionCardDark,
  warningsLight,
  warningsDark,
  React
};